var map = {
	"./affix/style/index.ts": "./components/affix/style/index.ts",
	"./alert/style/index.ts": "./components/alert/style/index.ts",
	"./anchor/style/index.ts": "./components/anchor/style/index.ts",
	"./avatar/style/index.ts": "./components/avatar/style/index.ts",
	"./badge/style/index.ts": "./components/badge/style/index.ts",
	"./breadcrumb/style/index.ts": "./components/breadcrumb/style/index.ts",
	"./button/style/index.ts": "./components/button/style/index.ts",
	"./calendar/style/index.tsx": "./components/calendar/style/index.tsx",
	"./card/style/index.tsx": "./components/card/style/index.tsx",
	"./carousel/style/index.tsx": "./components/carousel/style/index.tsx",
	"./cascader/style/index.ts": "./components/cascader/style/index.ts",
	"./checkbox/style/index.ts": "./components/checkbox/style/index.ts",
	"./col/style/index.ts": "./components/col/style/index.ts",
	"./collapse/style/index.tsx": "./components/collapse/style/index.tsx",
	"./comment/style/index.ts": "./components/comment/style/index.ts",
	"./config-provider/style/index.ts": "./components/config-provider/style/index.ts",
	"./date-picker/style/index.ts": "./components/date-picker/style/index.ts",
	"./descriptions/style/index.ts": "./components/descriptions/style/index.ts",
	"./divider/style/index.ts": "./components/divider/style/index.ts",
	"./drawer/style/index.ts": "./components/drawer/style/index.ts",
	"./dropdown/style/index.ts": "./components/dropdown/style/index.ts",
	"./empty/style/index.ts": "./components/empty/style/index.ts",
	"./float-button/style/index.ts": "./components/float-button/style/index.ts",
	"./form/style/index.ts": "./components/form/style/index.ts",
	"./grid/style/index.ts": "./components/grid/style/index.ts",
	"./image/style/index.ts": "./components/image/style/index.ts",
	"./input-number/style/index.tsx": "./components/input-number/style/index.tsx",
	"./input/style/index.ts": "./components/input/style/index.ts",
	"./layout/style/index.ts": "./components/layout/style/index.ts",
	"./list/style/index.tsx": "./components/list/style/index.tsx",
	"./mentions/style/index.ts": "./components/mentions/style/index.ts",
	"./menu/style/index.ts": "./components/menu/style/index.ts",
	"./message/style/index.ts": "./components/message/style/index.ts",
	"./modal/style/index.ts": "./components/modal/style/index.ts",
	"./notification/style/index.ts": "./components/notification/style/index.ts",
	"./page-header/style/index.ts": "./components/page-header/style/index.ts",
	"./pagination/style/index.tsx": "./components/pagination/style/index.tsx",
	"./popconfirm/style/index.ts": "./components/popconfirm/style/index.ts",
	"./popover/style/index.ts": "./components/popover/style/index.ts",
	"./progress/style/index.ts": "./components/progress/style/index.ts",
	"./qrcode/style/index.ts": "./components/qrcode/style/index.ts",
	"./radio/style/index.tsx": "./components/radio/style/index.tsx",
	"./rate/style/index.ts": "./components/rate/style/index.ts",
	"./result/style/index.tsx": "./components/result/style/index.tsx",
	"./row/style/index.ts": "./components/row/style/index.ts",
	"./segmented/style/index.ts": "./components/segmented/style/index.ts",
	"./select/style/index.ts": "./components/select/style/index.ts",
	"./skeleton/style/index.ts": "./components/skeleton/style/index.ts",
	"./slider/style/index.tsx": "./components/slider/style/index.tsx",
	"./space/style/index.tsx": "./components/space/style/index.tsx",
	"./spin/style/index.ts": "./components/spin/style/index.ts",
	"./statistic/style/index.tsx": "./components/statistic/style/index.tsx",
	"./steps/style/index.tsx": "./components/steps/style/index.tsx",
	"./switch/style/index.ts": "./components/switch/style/index.ts",
	"./table/style/index.ts": "./components/table/style/index.ts",
	"./tabs/style/index.ts": "./components/tabs/style/index.ts",
	"./tag/style/index.ts": "./components/tag/style/index.ts",
	"./timeline/style/index.tsx": "./components/timeline/style/index.tsx",
	"./tooltip/style/index.ts": "./components/tooltip/style/index.ts",
	"./tour/style/index.ts": "./components/tour/style/index.ts",
	"./transfer/style/index.tsx": "./components/transfer/style/index.tsx",
	"./tree-select/style/index.tsx": "./components/tree-select/style/index.tsx",
	"./tree/style/index.ts": "./components/tree/style/index.ts",
	"./typography/style/index.tsx": "./components/typography/style/index.tsx",
	"./upload/style/index.ts": "./components/upload/style/index.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.tsx?$";